import React from 'react';
import { useParams } from 'react-router-dom'; 
import Navbar from './Navbar';
import ContentItem from './ContentItem'; 
import dummyData from '../dummyData'; 
import './CategoryPage.css'; 

function CategoryPage() {
  let { categoryName } = useParams(); 

  const categoryDisplayNames = {
    'cold-knowledge': '冷知识',
    'strange-questions': '怪问题',
    'ai-generated': 'AI瞎编',
    'anti-common-sense': '反常识',
    'useless-inventions': '无用发明',
  };

  const displayName = categoryDisplayNames[categoryName] || categoryName || '所有分类';
  const items = dummyData[categoryName] || [];

  return (
    <div>
      <Navbar />
      <div className="category-page-content">
        <h1>分类：{displayName}</h1>
        {items.length > 0 ? (
          <div className="content-item-list">
            {items.map(item => (
              <ContentItem key={item.id} item={{...item, category: categoryName}} />
            ))}
          </div>
        ) : (
          <p>该分类下暂时还没有内容哦，敬请期待！</p>
        )}
      </div>
    </div>
  );
}

export default CategoryPage;
